<template>
  <div class="fav-content__wrapper">
    
    <Sticky
    :top="96"
    :show="96"
    stickyClass="scroll_top_nav"
    :stickyShowBefore="true"
    :ignore="!isMobile">
    <div class="fav-match-header">
      <h1 class="fav-title" v-if="!isMobile">{{ $t("FAVOURITES_MATCHES") }}</h1>
        <div class=" nav-pill__wrapper sub-nav__child fav-pill-wrapper"
          v-show="$route.name === 'footballFavMatches'">
          <template v-for="(o, index) in matchTab" :key="index">
            <div class="nav-pill btn-aspn-default"
              :class="o.selected ? 'selected' : ''"
              @click="selectMatchTab(o)">
              <span>{{ $t(o.name) }}</span>
              <!-- <div class="sub-nav__child-indicator" v-if="o.selected"></div> -->
            </div>
          </template>
        </div>
      </div>
      </Sticky>
  
      <!-- :class="favList ? 'display-flex' : 'display-flex-center'" -->
    <div
      class="fav-card__container flex-col display-flex"
    >
      <template v-if="!favList">
        <!-- <p class="fav-subtitle fav-subtitle-1line">
          {{ isMobile ? $t("TAP_ON") : $t("CLICK_ON") }}
          <img
            class="fav-icon__sample"
            src="../../../static/images/icons/icon-star-grey.png"
            alt=""
          />{{ $t("ADD_MATCH") }}
        </p>
        <FavCardMatch /> -->
        <div class="fav-no-data-box">
          <NoData text="FAV_MATCH_NO_FIXTURE" class="fav-no-data"  v-if="matchSelected === 1">
            <br />
            <div class="nav-pill selected choose-team-button"
              @click="handleChooseTeam()">
              {{ $t('CHOOSE_TEAM') }}
            </div>
          </NoData>
          <NoData text="FAV_MATCH_NO_RESULTS" class="fav-no-data" v-if="matchSelected === 2" />
        </div>
      </template>
      <div v-show="favList">
        <MatchContent
          v-show="currentSportType === 'football'"
          ref="footballMatchContentChild"
          class="match-content__wrapper"
          style="min-height: 15rem"
          type="fav"
          :params="{
            selectedCurrentChildMenuIndex: matchSelected
          }"
          @favChangeEmit="listenFavChangeMatchContentEvent"
          @isDataReturn="isDataReturn"
        ></MatchContent>
        <BasketballMatchContent
          v-show="currentSportType === 'basketball'"
          ref="basketballMatchContentChild"
          class="match-content__wrapper"
          style="min-height: 15rem"
          type="fav"
          @favChangeEmit="listenFavChangeMatchContentEvent"
          @isDataReturn="isDataReturn"
        ></BasketballMatchContent>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FavCardMatch from "./components/FavCardMatch.vue";
import MatchContent from "@/components/MatchContent3.vue";
import BasketballMatchContent from "@/components/BasketballMatchContent.vue";
import moment from "moment";

export default {
  components: {
    FavCardMatch,
    MatchContent,
    BasketballMatchContent,
  },
  props: [
    'favTeamUpdate'
  ],
  data() {
    return {
      favList: true,
      matchSelected: 1,
      matchTab: [
        {
          name: 'FIXTURES',
          id: 1,
          selected: true
        },
        {
          name: 'RESULTS',
          id: 2,
          selected: false
        }
      ],
    };
  },
  mounted() {
    this.commonVerifyLogin();
    if (this.isLogin) {
      this.init();
    }
  },
  watch: {
    userSwitchCountryLang: {
      deep: true,
      handler(newVal, oldVal) {
        this.init();
      },
    },
    currentSportType: {
      handler(newVal, oldVal) {
        this.init();
      },
    },
    favTeamUpdate(newVal) {
      if(newVal === true) {
        if(this.matchSelected === 1) {
          this.getFavMatchListData();
        }
        
      }
    }
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "userInfo",
      "currentLocale",
      "isMobile",
      "currentLanguageObj",
      "userSwitchCountryLang",
      "currentSportType",
    ]),
  },
  methods: {
    ...mapActions(["getFavMatchList", "commonVerifyLogin"]),

    init() {
      this.getFavMatchListData();
    },

    getFavMatchListData() {
      let params = {
        token: this.userInfo.token,
        timeZone: this.$tools.getCurrentTimeZone(),
        date: moment(new Date()).format("YYYY-MM-DD"),
        isCallInterval: false,
        isLiveOnly: false,
        type: 1
      };

      this.$nextTick(() => {
        if (this.currentSportType === "football")
          this.$refs.footballMatchContentChild.getFavMatchListData(params);
        else if (this.currentSportType === "basketball")
          this.$refs.basketballMatchContentChild.getFavMatchListData(params);
      });
    },
    isDataReturn(data) {
      this.favList = data;
    },
    listenFavChangeMatchContentEvent(matchList) {
      // this.$refs.footballMatchContentChild.initMatchList(matchList)
    },
    selectMatchTab(o) {
      this.matchTab.forEach(x => {
        x.selected = false;
      })
      o.selected = true;
      this.matchSelected = o.id
      this.$refs.footballMatchContentChild.getFavMatchListData2(this.matchSelected)
    },
    handleChooseTeam() {
      if(this.isMobile) {
        this.$router.push({
          name: 'footballFavTeams'
        })
        this.$emit('updateToTeamTab')
      } else {
        this.$emit('updateToTeamTab')
      }
    }
  },
};
</script>

<style scoped>
.fav-card__container {
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  margin-top: 0;
  /* background-color: var(--color-background-default-secondary); */
  
  border-radius: 16px;
}
@media(max-width: 768px) {  /* for test */
.fav-card__container {
  margin-top: 0;
  padding-top: 0;
  border-radius: 0;
  background-color: var(--color-background-default-default);
}
}
</style>


<style scoped>

.fav-match-header {
  padding: 16px;
  background-color: var(--color-background-default-secondary);
  border-radius: 16px;
}
.nav-pill__wrapper {
  padding: 0 8px 8px 0px;
  box-sizing: border-box;
  margin-right: 0 !important;
  width: 100%;
}
.nav-pill {
  flex: 1;
  border: 1px solid var(--color-border-default-default);
  padding: 8px;
  font-size: 16px;
  color: var(--color-text-default-default);
	letter-spacing: 0.64px;
}

.nav-pill.selected {
  background-color: var(--color-background-brand-default);
  border: 1px solid var(--color-background-brand-default);
  color: var(--color-button-active);
}

.fav-pill-wrapper {
  margin-bottom: 0;
}
@media(max-width: 768px) {  /* for test */

.fav-match-header {
  border-radius: 0;
  padding: 8px;
}
.nav-pill:last-child {
  margin-right: 0;
}
.nav-pill {
  border-radius: 17px;
  font-size: 13px;
}
.match-content__wrapper {
  width: calc(100% - 1rem);
  background: none;
  margin: 0 0.5rem;
  padding: 0;
  box-sizing: border-box;
}
.nav-pill__wrapper {
  padding-right: 0;
  padding-bottom: 0;
}
.scroll_top_nav {
    top:calc( 45.59px + 48.89px);
    border-bottom: 1px solid var(--color-border-default-default);
    width: 100%;
    background: var(--color-background-default-secondary);
    left: 0;
  }
}
</style>

<style>
.fav-no-data-box {
  padding: 16px; 
  margin: 0;
  border-radius: 16px;
  background-color: var(--color-background-default-secondary);
}
.fav-no-data {
  background-color: var(--color-background-default-tertiary) !important;
  display: block;
  border-radius: 16px;
}
.choose-team-button {
  display: inline-block; 
  margin-top: 8px;
  border-radius: 17px;
  padding: 8px 24px !important;
}
@media(max-width: 768px) {  /* for test */

.fav-no-data-box {
  margin: 16px 8px;
  background-color: var(--color-background-default-secondary);
  
}
.fav-no-data {
  background-color: var(--color-background-default-tertiary) !important;
}
}
</style>